<template>
  <el-dialog :visible.sync="visible" width="min(560px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="readonly && form.id" class="doc-dialog-actions">
          <el-button v-if="isAuth('finance:openingCustomer:update') || isAuth('finance:openingCustomer:save')" type="primary" size="small" :disabled="!canEditDoc" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('finance:openingCustomer:delete') || isAuth('finance:openingCustomer:save')" type="danger" size="small" :disabled="!canEditDoc" @click="deleteFromView">删除</el-button>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" :disabled="readonly" label-width="100px">
      <el-form-item label="会计年度" prop="financePeriodId">
        <el-select v-model="form.financePeriodId" filterable style="width:100%">
          <el-option v-for="p in years" :key="p.financePeriodId" :label="p.year + '年'" :value="p.financePeriodId" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户" prop="customerId">
        <el-input :value="form.partnerName" readonly placeholder="请选择客户">
          <el-button v-if="!readonly" slot="append" @click="picker = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="客户编码" prop="partnerCode"><el-input v-model="form.partnerCode" readonly /></el-form-item>
      <el-form-item label="客户名称" prop="partnerName"><el-input v-model="form.partnerName" readonly /></el-form-item>
      <el-form-item label="期初应收" prop="amount">
        <el-input-number v-model="form.amount" :min="0" :precision="2" style="width:100%" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
    <CustomerSelector :visible.sync="picker" @select="onPick" />
  </el-dialog>
</template>

<script>
import CustomerSelector from '../../components/CustomerSelector.vue'
import request from '../../api/request'
import auth from './financeAuth'

export default {
  name: 'OpeningCustomerAddOrUpdate',
  mixins: [auth],
  components: { CustomerSelector },
  data() {
    return {
      visible: false, readonly: false, picker: false, periods: [],
      form: this.blank(),
      rules: {
        financePeriodId: [{ required: true, message: '会计年度不能为空', trigger: 'change' }],
        customerId: [{ required: true, message: '客户不能为空', trigger: 'change' }],
        partnerCode: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        partnerName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    years() {
      return Array.from(new Map(this.periods.filter(p => p.financePeriodId)
        .map(p => [p.financePeriodId, { financePeriodId: p.financePeriodId, year: p.year }])).values())
    },
    dialogTitle() {
      if (this.readonly) return '查看客户期初'
      return this.form.id ? '修改客户期初' : '新增客户期初'
    }
  },
  methods: {
    blank() {
      return { kind: 'openingCustomer', financePeriodId: '', customerId: '', partnerCode: '', partnerName: '', amount: 0 }
    },
    loadPeriods() { request.get('/finance/period/list').then(res => { this.periods = res.data || [] }).catch(() => {}) },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.picker = false
      this.loadPeriods()
      if (!id) {
        this.form = this.blank()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/finance/doc/info', { params: { kind: 'openingCustomer', id } }).then(res => {
        this.form = Object.assign(this.blank(), res.data || {})
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() { this.form = this.blank(); this.readonly = false },
    editFromView() {
      if (!this.assertCanEditDoc('edit')) return
      this.readonly = false
    },
    deleteFromView() {
      if (String(this.form.approveStatus) === '2') {
        this.$message.warning('已审核的单据不可删除，请先弃审')
        return
      }
      this.$confirm('确定删除该客户期初?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/doc/delete', { kind: 'openingCustomer', id: this.form.id }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    onPick(row) { this.form.customerId = row.customerId; this.form.partnerCode = row.customerCode; this.form.partnerName = row.customerName },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/finance/doc/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
</style>
